import React, { useCallback, useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import HttpQueryContext from "./HttpQueryContext";
import httpClient from "@/apis/http";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
    },
  },
});

const contextValue = { queryClient };

function HttpQueryProvider({ children }) {
  const [loading, setLoading] = useState(true);
  const configure = useCallback(async () => {
    await httpClient.configure();
    setLoading(false);
  }, []);

  useEffect(() => {
    configure();
  }, [configure]);

  if (loading) {
    return null;
  }

  return (
    <HttpQueryContext.Provider value={contextValue}>
      <QueryClientProvider client={queryClient}>
        <>{children}</>
      </QueryClientProvider>
    </HttpQueryContext.Provider>
  );
}

export default HttpQueryProvider;
